import api from './axios.v2.withoutTransform'

// Sou-Sou saved cards (SOU-3.2 API, shared wallet with the membership card). Responses are plain objects, not the {statusCode, message, data} envelope.
const BASE = 'souSou/me/payment-methods'

const list = () => api(BASE, 'GET', {})
const createSetupIntent = () => api(`${BASE}/setup-intent`, 'POST', {})
const register = (setupIntentId, setAsDefault = true) => api(BASE, 'POST', { setupIntentId, setAsDefault })
const setDefault = paymentMethodId => api(`${BASE}/${encodeURIComponent(paymentMethodId)}/default`, 'PUT', {})
const remove = paymentMethodId => api(`${BASE}/${encodeURIComponent(paymentMethodId)}`, 'DELETE', {})

export default { list, createSetupIntent, register, setDefault, remove }
